import React, {useEffect} from 'react'
//import {useIntl} from 'react-intl'
import {useLocation} from 'react-router-dom'

// Components
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

// Project Components
import Seo from '@salesforce/retail-react-app/app/components/seo'

// Others

//Hooks
import useEinstein from '@salesforce/retail-react-app/app/hooks/use-einstein'

// Constants
import {
    HOME_SHOP_PRODUCTS_CATEGORY_ID,
    HOME_SHOP_PRODUCTS_LIMIT,
    MAX_CACHE_AGE
} from '../../constants'

import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import {useProductSearch} from '@salesforce/commerce-sdk-react'

import HeroBanner from './partials/home-banner'
import WesternStyleContent from './partials/western-style-content'
import TopCategoriesContent from './partials/top-categories-content'
import ContentRenderer from '../../components/content-renderer'
import homeCategoryBannersThemes from '../../theme/components/homePage/home-category-banners'
import HomeTopBrands from './partials/home-top-brands'
import PromoBanner from '../../components/_app/partials/promo-banner'

const Home = () => {
    //const intl = useIntl()
    const einstein = useEinstein()
    const {pathname} = useLocation()

    // useServerContext is a special hook introduced in v3 PWA Kit SDK.
    // It replaces the legacy `getProps` and provide a react hook interface for SSR.
    // it returns the request and response objects on the server side,
    // and these objects are undefined on the client side.
    const {res} = useServerContext()
    if (res) {
        res.set('Cache-Control', 'public, s-maxage=300, stale-while-revalidate=30')
    }

    const {data: productSearchResult, isLoading} = useProductSearch({
        parameters: {
            refine: [`cgid=${HOME_SHOP_PRODUCTS_CATEGORY_ID}`, 'htype=master'],
            expand: ['promotions', 'variations', 'prices', 'images', 'custom_properties'],
            perPricebook: true,
            allVariationProperties: true,
            limit: HOME_SHOP_PRODUCTS_LIMIT
        }
    })

    /**************** Einstein ****************/
    useEffect(() => {
        einstein.sendViewPage(pathname)
    }, [])

    return (
        <Box data-testid="home-page" layerStyle="page">
            <Seo
                title="Cavender's Western Wear, Cowboy Boots, Hats & Accessories"
                description="Cavender's has been a trusted western wear and cowboy boots outfitter for over 50 years. Discover why our loyal customers love our collection of western apparel."
                keywords="cowboy boots, western wear, cowboy hat Cavender's"
            />
            <PromoBanner slotIDs="home-hero-promo-text" />
            <HeroBanner />
            <WesternStyleContent />
            <ContentRenderer
                color="white"
                fontFamily="Montserrat"
                contentIds="home-category-banners"
                sx={homeCategoryBannersThemes}
                isSlot={true}
            />
            <HomeTopBrands />
            <TopCategoriesContent />
            <ContentRenderer contentIds="home-configuration" isSlot={true} />
        </Box>
    )
}

Home.getTemplateName = () => 'home'

export default Home
